import React from 'react';
import { ListItem } from './list-item';
import { ListResultsProps } from 'app/area/experience-transfer/list/types-store';
import { ListHeading } from 'app/area/experience-transfer/list/components/list-heading';
import styles from './list-results-desktop.scss';

export const ListResultsDesktop: React.FC<ListResultsProps> = ({
  listItems, deletingExperienceTransfer, deleteExperienceTransfer, translation
}) => <div className={styles.desktopView}>
    <ListHeading translation={translation} />
    {listItems.map(listItem => {
      return <ListItem
        key={listItem.id}
        item={listItem}
        deleting={deletingExperienceTransfer?.includes(listItem.id)}
        deleteExperienceTransfer={deleteExperienceTransfer}
        translation={translation} />;
    })}
  </div>;
